import { Form, FormSelect } from "react-bootstrap";
import { ApiTableColumn } from "../../../types/ApiTable/ApiTableColumn";
import { useContext, useEffect, useState } from "react";
import { TableContext } from "../Context/TableContext";

interface FilterSelectProps {
  column: ApiTableColumn;
}

const FilterSelect = ({ column }: FilterSelectProps) => {
  const {
    state: { filters },
    updateFilter,
    clearFilter,
  } = useContext(TableContext)!;
  const { labelKey, valueKey, options } = column.filter!.selectOptions!;
  const [currentFilterValue, setCurrentFilterValue] = useState(
    filters?.find((f) => f.field === column.field),
  );

  const getFilterServiceText = (column: ApiTableColumn, value: string) => {
    if (!value) return "";
    return `${column.filter?.filterKey ?? column.field} ${
      column.filter?.selectOptions?.operator ?? "cn"
    } ${value}`;
  };

  const onChange = (selected: any) => {
    if (!selected.target.value || selected.target.value.trimStart() === "") {
      clearFilter(column.field);
      setCurrentFilterValue(undefined);
    } else {
      const selectedOption = options.find((o) => {
        const key = o[valueKey ?? "value"];
        return key.toString() === selected.target.value;
      });
      const filter = {
        field: column.field,
        filterText: `${column.label} = ${selectedOption[labelKey ?? "label"]}`,
        value: selected.target.value,
        filterServiceText: getFilterServiceText(column, selected.target.value),
      };
      updateFilter(filter);
      setCurrentFilterValue(filter);
    }
  };

  useEffect(() => {
    setCurrentFilterValue(filters?.find((f) => f.field === column.field));
  }, [filters, column]);

  return (
    <Form.Group className="w-100">
      {column.filter?.label && (
        <Form.Label className="mb-0">{`Select a ${column.label}`}</Form.Label>
      )}
      <FormSelect
        onChange={onChange}
        name="layer"
        value={currentFilterValue?.value ?? ""}>
        <option value="">{`Any ${column.label.toLowerCase()}`}</option>
        {options.map((option: any, index: number) => (
          <option key={index} value={option[valueKey ?? "value"]}>
            {option[labelKey ?? "label"]}
          </option>
        ))}
      </FormSelect>
    </Form.Group>
  );
};

export default FilterSelect;
